'use strict';//Indicating browser should run only in java script mode

var EMRCommonCalender = angular.module('EMR.CommonCalender', [])